export default __webpack_public_path__ + "static/DMSans-Italic-d6b94ca60c9e64e173717c395a421dc4.woff";